import { CascadiaJsonFormContext } from "@certn/forms";
import { ArrayControlProps } from "@jsonforms/core";
import { withJsonFormsArrayControlProps } from "@jsonforms/react";
import { useContext } from "react";

import { ReferenceCheckControl } from "./ReferenceCheckControl";
import { ReferenceCheckSummaryControl } from "./ReferenceCheckSummaryControl";

function InternalReferenceCheckControl(props: ArrayControlProps) {
  const { isSummary } = useContext(CascadiaJsonFormContext);

  if (isSummary) {
    return <ReferenceCheckSummaryControl {...props} />;
  }

  return <ReferenceCheckControl {...props} />;
}

export const ReferenceCheckControlRenderer = withJsonFormsArrayControlProps(
  InternalReferenceCheckControl
);
